import React from "react";
import "./TechnicalWriting.css";
import BlogCarousel from "./BlogCarousel";
import {
  contributedBlogs,
  realJavaScriptProject,
  realPythonProject,
  crossPostBlogs,
} from "../../data/technicalWriting";
import BlogBrowser from "./BlogBrowser";
import ProfileCard from "./ProfileCard";

function TechnicalWriting() {
  return (
    <div id="TechnicalWriting">
      <h1>Technical Writing</h1>
      <div className="my-blog">
        <h2> My Blogs </h2>

        <div className="realpythonproject">
          <h3>
            {" "}
            <a
              style={{ color: "white" }}
              href={realPythonProject.url}
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              {realPythonProject.name}{" "}
            </a>
          </h3>
          <h3>
            {" "}
            I created this blog in November,2020. I am the sole manager of this
            blog. All the articles are written by me unless the author is 'Guest Post'. As of July,2022 it receives about 12,000+ views per month. It
            contains articles related to Python, JavaScript/TypeScript, React,
            SQL, DataScience etc. In July,2022 I created a separate website for
            JavaScript related stuff.{" "}
          </h3>
          <BlogBrowser
            blog_name={realPythonProject.name}
            blog_url={realPythonProject.url}
          />
        </div>
      </div>
      <div className="cross-post">
        <h2> My Blogging Profiles</h2>
        <div className="cross-post-profiles">
          {crossPostBlogs.blogs.map((blog) => (
            <ProfileCard
              name={blog.name}
              profileURL={blog.profileURL}
              views={blog.views}
              followers={blog.followers}
            />
          ))}
        </div>
      </div>

      <div className="blog-carousel">
        <h2>Blogs and Publications I have contributed to </h2>
        <BlogCarousel contributedBlogs={contributedBlogs.blogs} />
      </div>
    </div>
  );
}

export default TechnicalWriting();
